import { httpGet } from '../services/http'
import authProvider from '../utils/authProvider'

const eventsApi = process.env.REACT_APP_EVENTS_API

const EventProvider = {
  getList: async (resource, { pagination, filter }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const url = `${eventsApi}?f=${JSON.stringify(filter)}&p=${JSON.stringify(pagination)}`
    const { data: response } = await httpGet({ url, config: { headers } })
    return Promise.resolve({ data: response.items, total: response.count })
  },

  getOne: async (resource, params) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpGet({ url: `${eventsApi}/${params.id}`, config: { headers } })
    return Promise.resolve({ data: response })
  },
}

export default EventProvider
